import { colours, device } from "@helpers";
import React from "react";
import styled from "styled-components";
import DropDownContent from "./DropDownContent";

const SubmenuContainer = styled.ul`
  background-color: ${colours.WHITE};
  display: ${({ isShown }) => (isShown ? "visible" : "none")};
  height: fit-content;
  overflow: hidden;
  padding: 0 0 20px 0;
  position: absolute;
  top: 80px;
  transform: translateX(-45%);
  width: 190vw;
  z-index: 99;
  @media (min-width: ${device.tablet}) {
    padding: 0 0 16px 0;
  }
  @media (min-width: ${device.desktopS}) {
    transform: translateX(-44.7%);
  }
`;

const NavbarSubMenu = ({ navInfo, isShown, setIsShown }) => {
	return (
		<>
			<SubmenuContainer isShown={isShown} aria-expanded={isShown}>
				<DropDownContent navInfo={navInfo} setIsShown={setIsShown} />
			</SubmenuContainer>
		</>
	);
};

export default NavbarSubMenu;
